import React, {Component} from 'react';
import classNames from 'classnames';
import TableData from '../../utils/tableUtil';
import * as formatter from "../../utils/formatters"

class GlobalPortfolioReduce extends Component {

  constructor(props){
    super(props)
  }

  render() {
    const tableClass = classNames({
      'table': true,
      'table-striped': this.props.striped,
      'table-bordered': this.props.bordered,
      'table-hover': this.props.hover,
      'table-condensed': this.props.condensed
    });

    let months = this.props.data.map( data => {
      return <TableData content={data.month}/>
    })

    let amounts = this.props.data.map( data => {
      return <TableData content={formatter.formatNumber(data.accoutns)}/>
    })

    return (
        <table className={tableClass}>
          <thead>
          <tr>
            <th>Meses</th>
            {months}
          </tr>
          </thead>
          <tbody>
          <tr>
            <th scope="row">Cantidades</th>
            {amounts}
          </tr>
          </tbody>
        </table>
    );
  }
}

export default GlobalPortfolioReduce;



// WEBPACK FOOTER //
// ./src/components/tables/globalPortfolioReduce.js